import { FC } from "react";

interface EasyPayLogoSVGProps {
    className?: string;
}

const EasyPayLogoSVG: FC<EasyPayLogoSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="125"
            height="50"
            viewBox="0 0 125 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_196_10688)">
                <mask
                    id="mask0_196_10688"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="21"
                    width="59"
                    height="29"
                >
                    <path d="M58.5937 21.5098H0V50.0007H58.5937V21.5098Z" fill="white" />
                </mask>
                <g mask="url(#mask0_196_10688)">
                    <mask
                        id="mask1_196_10688"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="-2092"
                        y="-822"
                        width="2355"
                        height="1189"
                    >
                        <path d="M262.28 -821.908H-2091.24V366.614H262.28V-821.908Z" fill="white" />
                    </mask>
                    <g mask="url(#mask1_196_10688)">
                        <mask
                            id="mask2_196_10688"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="20"
                            width="60"
                            height="31"
                        >
                            <path d="M59.9888 20.252H0V50.9775H59.9888V20.252Z" fill="white" />
                        </mask>
                        <g mask="url(#mask2_196_10688)">
                            <mask
                                id="mask3_196_10688"
                                style={{ maskType: "luminance" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="21"
                                width="59"
                                height="29"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.07421 32.6829C2.9347 33.521 3.07421 35.3366 3.49274 36.3142C4.19029 37.9901 5.58538 38.8281 7.39899 38.8281C9.49163 38.8281 11.0262 38.1298 12.0028 37.4315L12.4213 39.9454C11.1657 40.7833 9.0731 41.4817 6.70144 41.4817C2.09766 41.4817 0.144531 37.9901 0.144531 33.8003C0.144531 27.9345 4.05078 21.51 9.63114 21.51C12.9793 21.51 14.7929 23.7446 14.7929 26.3982C14.5139 31.426 9.49163 32.8227 3.07421 32.6829ZM9.07174 24.0245C6.28155 24.0245 4.18892 27.0971 3.35187 30.1696C7.95566 30.1696 11.7224 29.4714 11.7224 26.5384C11.7224 24.8624 10.6063 24.0245 9.07174 24.0245ZM29.2992 32.2637C28.7411 35.6156 28.4621 38.9674 28.6016 41.2021H25.8114C25.8114 40.0848 25.9509 38.2692 26.23 36.1743H26.0905C24.1373 40.0848 21.7656 41.6211 19.394 41.6211C16.3248 41.6211 14.3717 38.9674 14.3717 35.1966C14.3717 28.4928 18.836 21.5098 26.3694 21.5098C28.0436 21.5098 29.8572 21.789 30.9732 22.2081L29.2992 32.2637ZM25.676 24.0245C21.2117 24.0245 17.5845 29.192 17.445 34.4992C17.445 36.594 18.1426 38.689 20.3747 38.689C22.8858 38.689 25.8155 35.0578 26.6526 30.03L27.6291 24.1642C27.3502 24.1642 26.6526 24.0245 25.676 24.0245ZM41.9972 24.8622C41.4391 24.4432 40.3231 24.0242 38.928 24.0242C37.1144 24.0242 35.8587 25.2811 35.8587 26.9571C35.8587 28.3537 36.6959 29.1917 38.2304 30.1693C40.1836 31.4262 41.4391 33.1022 41.4391 35.1971C41.4391 39.2473 38.5095 41.482 34.7427 41.482C32.9291 41.482 31.255 40.7835 30.4179 40.225L31.255 37.8507C32.0921 38.4094 33.6266 39.1077 35.0217 39.1077C36.9749 39.1077 38.37 37.711 38.37 36.0351C38.37 34.4988 37.8119 33.6609 35.9983 32.5435C34.0451 31.2866 32.9291 29.6106 32.9291 27.6554C32.9291 24.3035 35.5798 21.6499 39.207 21.6499C40.7416 21.6499 42.1367 22.0689 42.8342 22.6276L41.9972 24.8622ZM52.1799 36.4534C50.3663 40.6433 48.5527 43.9951 46.181 46.509C44.228 48.7437 42.1353 49.5816 41.1587 49.861L40.4612 47.0677C41.1587 46.7884 42.4144 46.2298 43.6699 45.2521C44.7859 44.2744 46.0416 42.7382 47.0182 40.7829C47.1576 40.5035 47.1576 40.2243 47.1576 39.9449L43.6699 21.9285H46.7391L48.4133 32.2635C48.8318 34.4982 48.9712 35.8948 49.2503 37.2914H49.3897C49.8084 36.0344 50.3663 34.7774 51.2035 32.5428L55.6677 21.7889H58.5973L52.1799 36.4534Z"
                                    fill="white"
                                />
                            </mask>
                            <g mask="url(#mask3_196_10688)">
                                <mask
                                    id="mask4_196_10688"
                                    style={{ maskType: "luminance" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="20"
                                    width="60"
                                    height="31"
                                >
                                    <path d="M59.9888 20.252H0V50.9775H59.9888V20.252Z" fill="white" />
                                </mask>
                                <g mask="url(#mask4_196_10688)">
                                    <path d="M65.564 14.5254H-6.98047V56.9826H65.564V14.5254Z" fill="white" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <mask
                    id="mask5_196_10688"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="45"
                    y="11"
                    width="39"
                    height="35"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M51.7562 45.2503C51.7562 45.2503 59.5687 32.4014 60.9638 26.3959C62.3588 20.3905 62.4984 17.1783 57.0576 16.6196C51.4772 16.0609 45.1992 16.6196 45.1992 16.6196C45.1992 16.6196 53.9883 11.0332 65.5675 11.4521C77.2862 11.7315 83.9827 16.6196 83.9827 16.6196C83.9827 16.6196 81.4715 17.5973 77.4258 17.8766C73.38 18.2956 71.8454 19.1335 72.1245 23.7424C72.4035 28.3512 74.0775 31.5634 74.0775 31.5634C74.0775 31.5634 67.5207 27.2339 63.475 31.5634C59.4291 35.8929 58.5921 37.8483 56.2204 40.6414C53.9883 43.4347 51.7562 45.2503 51.7562 45.2503Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask5_196_10688)">
                    <mask
                        id="mask6_196_10688"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="-2092"
                        y="-822"
                        width="2355"
                        height="1189"
                    >
                        <path d="M262.279 -821.91H-2091.24V366.612H262.279V-821.91Z" fill="white" />
                    </mask>
                    <g mask="url(#mask6_196_10688)">
                        <path d="M91.1044 4.32812H38.2305V52.2321H91.1044V4.32812Z" fill="#136BB5" />
                    </g>
                </g>
                <mask
                    id="mask7_196_10688"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="60"
                    y="0"
                    width="11"
                    height="11"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M65.1473 0C67.9375 0 70.1696 2.23458 70.1696 5.02783C70.1696 7.82106 67.9375 10.0556 65.1473 10.0556C62.3571 10.0556 60.125 7.82106 60.125 5.02783C60.125 2.23458 62.4967 0 65.1473 0Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask7_196_10688)">
                    <mask
                        id="mask8_196_10688"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="-2092"
                        y="-822"
                        width="2355"
                        height="1189"
                    >
                        <path d="M262.279 -821.91H-2091.24V366.612H262.279V-821.91Z" fill="white" />
                    </mask>
                    <g mask="url(#mask8_196_10688)">
                        <path d="M77.1518 -6.98438H53.1562V17.0375H77.1518V-6.98438Z" fill="#C58811" />
                    </g>
                </g>
                <mask
                    id="mask9_196_10688"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="73"
                    y="21"
                    width="53"
                    height="29"
                >
                    <path d="M125.002 21.5098H73.9414V50.0007H125.002V21.5098Z" fill="white" />
                </mask>
                <g mask="url(#mask9_196_10688)">
                    <mask
                        id="mask10_196_10688"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="-2092"
                        y="-822"
                        width="2355"
                        height="1189"
                    >
                        <path d="M262.279 -821.908H-2091.24V366.614H262.279V-821.908Z" fill="white" />
                    </mask>
                    <g mask="url(#mask10_196_10688)">
                        <mask
                            id="mask11_196_10688"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="73"
                            y="20"
                            width="53"
                            height="31"
                        >
                            <path d="M125.56 20.252H73.9414V50.9775H125.56V20.252Z" fill="white" />
                        </mask>
                        <g mask="url(#mask11_196_10688)">
                            <mask
                                id="mask12_196_10688"
                                style={{ maskType: "luminance" }}
                                maskUnits="userSpaceOnUse"
                                x="73"
                                y="21"
                                width="53"
                                height="29"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M82.1822 41.4784C80.3686 41.4784 79.1129 41.0595 78.4154 40.6405H78.2759L76.8808 48.8805H73.9512L77.4388 28.6296C77.8573 26.2554 78.1363 23.7415 78.4154 21.7862H81.0661L80.508 25.4173H80.6475C82.1822 22.9034 84.5537 21.3672 86.786 21.3672C90.5526 21.3672 92.0873 24.719 92.0873 28.3502C92.2268 35.1937 87.902 41.4784 82.1822 41.4784ZM85.8094 24.1612C83.4377 24.1612 80.508 27.094 79.671 32.5408L78.8339 37.848C79.5314 38.5463 80.7871 38.9654 82.1822 38.9654C85.9488 38.9654 89.1575 33.6582 89.1575 28.6304C89.1575 26.5354 88.3205 24.1612 85.8094 24.1612ZM107.433 32.2613C106.875 35.6133 106.596 38.9651 106.736 41.1997H103.946C103.946 40.0824 104.085 38.2668 104.364 36.1719H104.225C102.271 40.0824 100.039 41.6187 97.5281 41.6187C94.4589 41.6187 92.5058 38.9651 92.5058 35.1943C92.5058 28.4905 96.97 21.5074 104.504 21.5074C106.178 21.5074 107.991 21.7867 109.107 22.2057L107.433 32.2613ZM103.805 24.021C99.3404 24.021 95.7132 29.1885 95.7132 34.4956C95.7132 36.5906 96.4107 38.6855 98.6428 38.6855C101.154 38.6855 104.084 35.0543 104.921 30.0265L105.897 24.1606C105.479 24.1606 104.781 24.021 103.805 24.021ZM118.595 36.4511C116.782 40.6409 114.968 43.9928 112.596 46.5067C110.643 48.7413 108.551 49.5793 107.574 49.8585L106.877 47.0654C107.574 46.786 108.83 46.2274 110.085 45.2498C111.201 44.2721 112.457 42.7358 113.434 40.7806C113.573 40.5012 113.573 40.2219 113.573 39.9426L110.085 21.9262H113.154L114.829 32.2612C115.247 34.4958 115.387 35.8924 115.666 37.289H115.805C116.224 36.0321 116.782 34.7751 117.619 32.5405L121.944 21.7866H125.013L118.595 36.4511Z"
                                    fill="white"
                                />
                            </mask>
                            <g mask="url(#mask12_196_10688)">
                                <mask
                                    id="mask13_196_10688"
                                    style={{ maskType: "luminance" }}
                                    maskUnits="userSpaceOnUse"
                                    x="73"
                                    y="20"
                                    width="53"
                                    height="31"
                                >
                                    <path d="M125.569 20.252H73.9512V50.9775H125.569V20.252Z" fill="white" />
                                </mask>
                                <g mask="url(#mask13_196_10688)">
                                    <path d="M131.982 14.5254H66.9707V56.9826H131.982V14.5254Z" fill="white" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_196_10688">
                    <rect width="125" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EasyPayLogoSVG;
